import React from 'react';
import { useParams } from 'react-router-dom';
import AulaBase from './Aula';

export { default } from './Curso';

// Wrapper que força remount completo ao trocar de aula.
// Sem isso, o React Router reutiliza a mesma instância do componente e o
// Plyr fica com estado corrompido entre navegações, causando tela branca.
export function Aula() {
  const { lessonId } = useParams();
  return <AulaBase key={lessonId} />;
}
